import styled from "@emotion/styled";

export const LensSubmissionErrorsContainer = styled.div`
    overflow-y: auto;
    display: flex;
    flex-direction: column;
`;
